import React from 'react';
import { HVAConversationProvider } from './HVADynamicAgentConversationContext';
import HVADynamicConversationModalContent from './HVADynamicConversationModalContent';
import { HVADynamicConversationModalProps } from './HVADynamicAgentData';

const HVADynamicConversationModal: React.FC<
  HVADynamicConversationModalProps
> = props => {
  return (
    <HVAConversationProvider>
      <HVADynamicConversationModalContent {...props} />
    </HVAConversationProvider>
  );
};

export default HVADynamicConversationModal;
